import { GenericObject } from '@synergy/models';

export const pickCommonPartial = <B extends GenericObject, F extends GenericObject>(
    baseObject: B,
    fullObject: F
): Partial<{ [P in keyof B & keyof F]: B[P] | F[P] }> => {
    const returnObject = {} as Partial<{ [P in keyof B & keyof F]: B[P] | F[P] }>;
    Object.keys(baseObject).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(fullObject, key)) {
            // TODO: check typings
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (returnObject as any)[key] = fullObject[key];
        }
    });

    return returnObject;
};
